require('./accountDebitsHeader.scss');
// @ vendors
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// const { connect } = require('react-redux');
// @ actions
import { authorizationsFilter } from 'actions/accountDebits/authorizations';
import { receiptsFilter } from 'actions/accountDebits/receipts';
import { removeFilter } from 'actions/filters';
// @ commons
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @ components
import DropdownAccounts from 'components/dropdownAccounts/dropdownAccounts';
import { OKButton } from 'commonsComponents/OKButton';
import Filters from 'components/commons/filters/filters';
import FilterTags from 'components/commons/filters/filterTags';
import CheckFilter from 'components/commons/filters/filters/checkFilter';
import DateFilter from 'components/commons/filters/filters/dateFilter';
import RadioFilter from 'components/commons/filters/filters/radioFilter';
import SelectorFilter from 'components/commons/filters/filters/selectorFilter';
// @ utilities
import { getCurrentAccounts } from 'utilities/currentAccountsHelper';
import { sortBy } from 'utilities/arrayHelper';
const moment = require('moment');
// @ constants
import {
    AUTHORIZATIONS_FILTERS,
    AUTHORIZATION_ACTIVE,
    AUTHORIZATION_ALL,
    AUTHORIZATION_CANCELED,
    RECEIPTS_FILTERS,
    RECEIPT_STATUS_CODES_CANCELED,
    RECEIPT_STATUS_CODES_PAID,
    RECEIPT_STATUS_CODES_REJECTED,
    RECEIPT_STATUS_CODES_RETURNED,
    RECEIPT_STATUS_CODES_CANCELATION_PENDING,
    RECEIPT_STATUS_CODES_PENDING,
    ACCOUNT_DEBITS_ISSUING_COMPANY_LABEL_ALL
} from 'constants/index';
const { BRING_DIRECT_DEBITS, WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');
const DATE_FILTER_MIN_DATE_LIMIT = moment().startOf('day').subtract(15, 'months');


class accountDebitsHeader extends PureComponent {

    constructor(props) {
        super(props);
        this.handleAccountChange = this.handleAccountChange.bind(this);
    }

    componentWillUnmount() {
        this.props.removeFilter();
    }

    handleAccountChange = (accountId) => {
        this.props.history.push(`/myprofile/accounts/${accountId}/debits`);
    }

    handleAuthorizationsFilter = () => {
        const { authorizationsFilter, immAccount, immFiltersAuthorizations } = this.props;
        const accountId = immAccount.get('accountId');
        authorizationsFilter(accountId, immFiltersAuthorizations)

    }

    handleReceiptsFilter = () => {
        const { receiptsFilter, immAccount, immFiltersReceipts } = this.props;
        const accountId = immAccount.get('accountId');
        receiptsFilter(accountId, immFiltersReceipts)
    }

    handleEditAccount = (accountId) => {
        this.props.history.push(`/myprofile/accounts/${accountId}/debits/change-account`);
    }

    setOptionRadioWithLabelValueText = (value) => {
        return Object.assign({
            value: value,
            label: formatText(`accountDebitsFilter-${value}`)
        });
    }

    radioOptions = () => {
        let options = [];

        options.push(this.setOptionRadioWithLabelValueText(AUTHORIZATION_ALL));
        options.push(this.setOptionRadioWithLabelValueText(AUTHORIZATION_ACTIVE));
        options.push(this.setOptionRadioWithLabelValueText(AUTHORIZATION_CANCELED));

       return options;
    }

    selectorOptions = () => {
        const { immAccount, immReceipts } = this.props;
        const receipts = immReceipts.get(immAccount.get('accountId'));
        let options = [];

        receipts && receipts.get('byId').map(receipt => {
            if (!options.find(option => option.value == receipt.get('nombre'))) {
                options.push({
                    value: receipt.get('nombre'),
                    label: receipt.get('nombre')
                });
            }
        });
        options = sortBy('label', options);

        return [
            {
                value: ACCOUNT_DEBITS_ISSUING_COMPANY_LABEL_ALL,
                label: formatText('accountDebitsFilter-all')
            },
            ...options
        ];
    }

    renderAuthorizationsFilters = () => {
        return (
            <Filters
                extraClass="account-debits-header__authorizations"
                filtersId={AUTHORIZATIONS_FILTERS}
                onFilter={this.handleAuthorizationsFilter}
                title="accountDebitsFilter-authorizationsFilter"
            >
                <div>
                    <h5 className="account-debits-header__filter-subtitle">
                        <FormattedText value="accountDebitsFilter-state" />
                    </h5>
                    <div>
                        <RadioFilter
                            filterId={'status'}
                            initialSelected={AUTHORIZATION_ALL}
                            noFilterId={AUTHORIZATION_ALL}
                            options={this.radioOptions()}
                        />
                    </div>
                </div>
            </Filters>
        )
    }

    renderReceiptsFilters = () => {
        return (
            <Filters
                extraClass="account-debits-header__receipts"
                filtersId={RECEIPTS_FILTERS}
                onFilter={this.handleReceiptsFilter}
                title="accountDebitsFilter-receiptsFilter"
            >
                <h5 className="account-debits-header__filter-subtitle">
                    <FormattedText value="accountDebitsFilter-issuingCompanyName" />
                </h5>
                <div>
                    <SelectorFilter
                        filterId={'name'}
                        initialSelected={ACCOUNT_DEBITS_ISSUING_COMPANY_LABEL_ALL}
                        noFilterId={ACCOUNT_DEBITS_ISSUING_COMPANY_LABEL_ALL}
                        options={this.selectorOptions()}
                    />
                </div>
                <h5 className="account-debits-header__filter-subtitle">
                    <FormattedText value="accountDebitsFilter-receiptsState" />
                </h5>
                <div>
                    <CheckFilter
                        filterId={'canceled'}
                        label={formatText('accountDebitsFilter-labelCanceled')}
                        value={RECEIPT_STATUS_CODES_CANCELED}
                    />
                </div>
                <div>
                    <CheckFilter
                        filterId={'pendingCanceled'}
                        label={formatText('accountDebitsFilter-labelCancelationpending')}
                        value={RECEIPT_STATUS_CODES_CANCELATION_PENDING}
                    />
                </div>
                <div>
                    <CheckFilter
                        filterId={'paid'}
                        label={formatText('accountDebitsFilter-labelPaid')}
                        value={RECEIPT_STATUS_CODES_PAID}
                    />
                </div>
                <div>
                    <CheckFilter
                        filterId={'pending'}
                        label={formatText('accountDebitsFilter-labelPending')}
                        value={RECEIPT_STATUS_CODES_PENDING}
                    />
                </div>
                <div>
                    <CheckFilter
                        filterId={'returned'}
                        label={formatText('accountDebitsFilter-labelReturned')}
                        value={RECEIPT_STATUS_CODES_RETURNED}
                    />
                </div>
                <div>
                    <CheckFilter
                        filterId={'rejected'}
                        label={formatText('accountDebitsFilter-labelRejected')}
                        value={RECEIPT_STATUS_CODES_REJECTED}
                    />
                </div>
                <h5 className="account-debits-header__filter-subtitle">
                    <FormattedText value="accountDebitsFilter-date" />
                </h5>
                <div>
                    <DateFilter
                        filterId={'date'}
                        minDate={DATE_FILTER_MIN_DATE_LIMIT}
                    />
                </div>
            </Filters>
        )
    }

    render() {
        const { immAccount, immAccounts, immAccountDebits, immFlagBasedFeatures, clearFilters } = this.props;
        const accountId = immAccount.get('accountId');
        const accountsById = immAccounts.get('byId');
        const accountsIndexes = getCurrentAccounts(immAccounts.get('byOrder').toJS(), accountsById);
        const tooltipElement = immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED) ? (
            <div className="account-debits-header__tooltip">
                <OKTooltip
                    content="inactiveAccounts-inactiveAccounts_consultiveDropdownCommonToolTip"
                    offset={[0, -15]}
                />
            </div>
        ) : '';
        const editAccountButton = immFlagBasedFeatures.get(BRING_DIRECT_DEBITS) ? (
            <div className="col-xs-4 account-debits-header__modify-account-container-button">
                <OKButton
                    modifier="link-complementary"
                    onClick={() => this.handleEditAccount(accountId)}
                >
                    <FormattedText value="accountDebits-editAccount" />
                </OKButton>
            </div>
        ) : null;
        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        <h1 className="account-debits-header__subtitle">
                            <FormattedText value="accountDebits-subtitle" />
                        </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-5">
                        <DropdownAccounts
                            immAccounts={accountsById}
                            accountsIndexes={accountsIndexes}
                            currentAccountId={accountId}
                            initialAccountIndex=""
                            onAccountChange={this.handleAccountChange}
                        />
                    </div>
                    {tooltipElement}
                    {editAccountButton}
                    <div className="col-xs-2 text-right account-debits-header__filter-button">
                        {
                            immAccountDebits.get('activeTab') == 0 ?
                                this.renderReceiptsFilters() :
                                this.renderAuthorizationsFilters()
                        }
                    </div>
                </div>
                <FilterTags
                    filtersId={immAccountDebits.get('activeTab') == 0 ? 'receipts' : 'authorizations'}
                    onFilter={immAccountDebits.get('activeTab') == 0 ? this.handleReceiptsFilter : this.handleAuthorizationsFilter}
                    clearFilters={clearFilters}
                />
            </div>
        );
    }
}

accountDebitsHeader.propTypes = {
    authorizationsFilter: PropTypes.func.isRequired,
    clearFilters: PropTypes.func,
    history: PropTypes.object.isRequired,
    immAuthorizations: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountDebits: PropTypes.object.isRequired,
    immFiltersAuthorizations: PropTypes.object,
    immFiltersReceipts: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    immReceipts: PropTypes.object,
    receiptsFilter: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired
};

export default connect(
    (state) => ({
        immAccountDebits: state.accountDebits,
        immAuthorizations: state.authorizations,
        immFiltersAuthorizations: state.filters.get('authorizations'),
        immFiltersReceipts: state.filters.get('receipts'),
        immReceipts: state.receipts,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        authorizationsFilter,
        receiptsFilter,
        removeFilter
    }
)(withRouter(accountDebitsHeader));
